<template>
  <v-app id="app">
    <Nav />
    <v-main style="min-height: calc(100vh - 36px)" class="lighten-5">
      <router-view />
      <v-snackbar
        v-model="showNotification"
        :timeout="timeout"
        :top="true"
        dark
        :color="color"
      >
        {{ message }}
      </v-snackbar>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { bus } from "./main";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import VueMeta from 'vue-meta'
export default {
  name: "App",
  components: {
    Nav,
    Footer,
  },
  data: () => ({
    showNotification: false,
    loading: false,
    timeout: 5000,
    color: "green",
    message: null,
    success: null,
    defaultErrorMsg: "Sorry, an error occured!",
  }),
 
  created() {
    bus.$on("updateNotification", (_status, err, entityName) => {
      this.showNotification = true;
      this.color = "green";
      if (_status === "OK") {
        this.message = entityName + " has been updated!";
      } else {
        this.color = "red";
        this.message = err;
      }
    });
    bus.$on("SaveNotification", (_status, err, entityName) => {
      this.showNotification = true;
      this.color = "green";
      if (_status === "OK") {
        this.message = entityName + " has been saved";
      } else {
        this.color = "red";
        if (err && err.title && err.title.includes("is not unique")){
          this.message = "Project with this name already exists. Please change the project name.";
        } else {
          this.message = err;
        }
      }
    });
    bus.$on("cloneNotification", (_status, err, entityName) => {
      this.showNotification = true;
      this.color = "green";
      if (_status === "OK") {
        this.message = entityName + " has been cloned";
      } else {
        this.color = "red";
        if (err && err.title && err.title.includes("is not unique")){
          this.message = "Project with this name already exists. Please change the project name.";
        } else {
          this.message = err;
        }
      }
    });
    bus.$on("deleteNotification", (_status) => {
      this.showNotification = true;
      this.color = "green";
      if (_status === "OK") {
        this.message = "Record deleted successfully!";
      } else {
        this.color = "red";
        this.message = this.defaultErrorMsg;
      }
    });
    bus.$on("publishNotification", (isPublished, _status) => {
      this.showNotification = true;
      this.color = "green";
      if (_status === "OK") {
        const desc = isPublished ? "published" : "unpublished";
        this.message = `Record ${desc} successfully!`;
      } else {
        this.color = "red";
        this.message = this.defaultErrorMsg;
      }
    });
    bus.$on("emptyFieldNotification", (message) => {
      this.showNotification = true;
      this.color = "red";
      this.message = message;
    });
    bus.$on("analysisStartNotification", (message) => {
      this.showNotification = true;
      this.color = "green";
      this.message = message;
    });
    bus.$on("errorNotification", (message) => {
      this.showNotification = true;
      this.color = "red";
      this.message = message;
    });
  },
};
</script>
<style scoped>
#app {
  font-family: "Roboto";
}
</style>